import React from 'react';
import Udesk from 'Udesk';
import DialogueManageIndexRoute from './route';
import FilterManage from '../components/filter-manage';
import ListManage from '../components/list-manage';
import './style.scss';
import UdeskLocales from 'UdeskLocales';

export default class DialogueManageIndexTemplate extends DialogueManageIndexRoute {
    render() {
        let { filterVisible, isUpdate, keyword } = this.privates;
        let { selectedFilter } = this.privates.storages;
        let { actions, locales } = this;
        return (
            <div className="udesk-qa-web-page">
                <div className="udesk-qa-web-page-body">
                    <div className="udesk-qa-web-page-body-root ticket-manage-page">
                        <div className="ticket-manage-page-left-part">
                            <FilterManage
                                ref={this.privates.filterManageRef}
                                type={Udesk.enums.filterTypes.survey.id}
                                filterManageTitle={
                                    /* 问卷筛选器 */ UdeskLocales['current'].pages.surveyManage
                                        .template.questionnaireFilter
                                }
                                onEditFilter={actions.editFilter}
                                allFilterTitle={
                                    /* 全部问卷 */ UdeskLocales['current'].pages.surveyManage
                                        .template.allQuestionnaires
                                }
                                onSelectedFilterChanged={actions.onSelectedFilterChanged}
                                isUpdate={isUpdate}
                                onFiltersEnd={actions.onFiltersEnd}
                            />
                        </div>
                        <div className="ticket-manage-page-right-part">
                            <ListManage
                                ref={this.privates.listManageRef}
                                title={
                                    /* 问卷管理 */ UdeskLocales['current'].pages.surveyManage
                                        .template.questionnaireManagement
                                }
                                cacheKey="survey-manage.index"
                                searchPlaceHolder={locales.labels.searchPlaceHolder}
                                type={Udesk.enums.filterTypes.survey.id}
                                editFilterVisible={filterVisible}
                                onEditFilterVisibleChanged={actions.onEditFilterVisibleChanged}
                                onViewItemDetail={actions.onViewItemDetail}
                                onPageChanged={actions.onPageChanged}
                                selectedFilter={selectedFilter}
                                onConditionFilterSaved={actions.onConditionFilterSaved}
                                keyword={keyword}
                                hideKeywordType
                                onSetDefault={actions.onSetDefault}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
